<template>
    <div :class="$common.getStyleName('prop-componesnts')">
        <div :class="$common.getStyleName('prop-1')" v-if="$modulList.prop === 1"><Prop1></Prop1></div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import Prop1 from './Prop1'

    export default {
        name: 'propBox',
        components: {
            Prop1,
        },
        data() {
            return {};
        },
        computed: {
            ...mapState(['$appConfig','$modulList','$common']),
            ...mapState('Module_Package', ['packagelist', 'packagelistDone']),
        },
    };
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// website/components/package/props/Index.vue